import React from "react";
import {AccountTreeOutlined} from "@mui/icons-material";
import Applet from "../../Applet";
import ObjectRelationshipTable from "../../../../components/Foundation/ObjectRelationshipTable";

// Related objects on the Detail tab. Edges reference the LOGICAL object, so this grid is queried by
// ParentUSID and does not re-query when a different revision of the same object is selected.
class ObjectRelationshipTableApplet extends Applet {

    render() {
        return <ObjectRelationshipTable applet={this}
                                        pageSize={this.props.PageSize ?? this.state.PageSize}
                                        placement={this.state.Placement}
                                        columns={this.state.Columns}
                                        title="Related objects"
                                        icon={<AccountTreeOutlined/>}
                                        enterpriseComponent={this.getEnterpriseComponent()}
                                        sort={this.state.Sort}
                                        menu={this.state.Menu}
                                        rowHeight={this.state.RowHeight}
                                        enableSearch={false}
                                        enableSort={true}
        />;
    }

    state = {
        Name: "ObjectRelationshipTableApplet",
        // ADD SITS IN THE GRID'S OWN MENU, not on the page: the action belongs to the thing it
        // changes, and the page header already carries the record's lifecycle actions.
        Menu: {options: [
            {displayValue: "Add related object", value: "Add Related Object"},
            {displayValue: "Refresh", value: "Refresh"},
        ]},
        RowHeight: 48,
        PageSize: {"default": 20, "xs": 3, "sm": 3, "md": 20, "lg": 20, "lx": 20},
        Placement: {
            "xl": [
                {id: "Actions"},
                {id: "SourceRelationshipName"},
                {id: "ChildObjectID"},
                {id: "ChildName"},
                {id: "ChildObjectClassification"},
            ],
        },
        Columns: [
            // How the edge READS from this end, which is more use than the type's bare name.
            {id: "SourceRelationshipName", width: 200, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Relationship", hideable: false},
            // OBJECT is the IDENTIFIER -- "SOP-00018 REV 1" -- and NAME is the name. They were one
            // column called "Object" showing only the name, which is not how anybody refers to a
            // record and does not tell two identically-named ones apart.
            {id: "ChildObjectID", width: 170, cellRenderer: "Related Object Id Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Object ID", hideable: false},
            // THE NAME FILLS THE WIDTH, as it does on the records grid, so the columns reach the
            // grid's edge instead of stopping short of it with blank space after Status.
            {id: "ChildName", flex: 1, minWidth: 300, cellRenderer: "Related Object Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Name", hideable: false},
            // An edge may legitimately span classifications (a Contract to a Supplier), so which kind
            // of thing sits at the far end is worth a column of its own.
            {id: "ChildObjectClassification", width: 160, cellRenderer: "Classification Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Type", hideable: false},
            // NO STATUS COLUMN: the Name cell carries "Name  REV n  [STATUS]" (Ed, 2026-10-28).
            // PINNED LEFT, matching every other grid in the app that offers row actions.
            {id: "Actions", width: 50, cellRenderer: "Action Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "", pinned: "left", hideable: false},
        ],
        Sort: [
            {
                "Identifier": "Relationship",
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "SourceRelationshipName",
                    "DisplayName": "Relationship",
                }],
            },
        ],
    };
}

export default ObjectRelationshipTableApplet;
